export default __webpack_public_path__ + "static/fakegoogle_2-de2b80d06713c153b156329065f19d03.jpg";